export default __webpack_public_path__ + "locales/pl/JavascriptSdk.json?hash=2d37318ce7791d39589bed463da85457";